<template>
  <CookieSettingPopup />
  <Cart />
  <!-- <V2Cart /> -->
  <V3Cart />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { userRepository } from './repository/userRepository'
import V3Cart from '~/components/v3/Cart.vue'
const router = useRouter()
const userStore = useUserStore()
const { $serverApi } = useNuxtApp()

// initapp
const { access_token } = storeToRefs(userStore)
const userRepo = userRepository($serverApi)

// middleware before each route change
router.beforeEach((to, from, next) => {
  // redirect to home page if not logged in and trying to access a restricted page
  if (!to.matched.length) {
    next({ name: 'index' })
  }

  next()
})

if (access_token.value) {
  userRepo
    .getUser({
      headers: {
        Authorization: `Bearer ${access_token.value}`
      },
      onResponse: ({ response }) => {
        if (response.status === 200) {
          userStore.update(response._data.data)
        } else {
          userStore.logout()
        }
      }
    })
    .then(() => {
      // do something after the promise is resolved
    })
    .catch((error) => console.log(error))
}

const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/

yup.addMethod(yup.string, 'phone', function (errorMessage) {
  return this.test(`test-phone-number`, errorMessage, function (value, ctx) {
    if (!value) {
      return true
    }
    if (!!value && !phoneRegExp.test(value)) {
      return ctx.createError({
        message: errorMessage || `${ctx.path} must be a valid phone number`
      })
    }
    return true
  })
})
</script>
